import React, { useContext, useState, useEffect } from 'react'
import { AnimatePresence } from 'framer-motion/dist/framer-motion'
import { UIContext } from '../../Context/UIContext'

import './Header.scss'

import Topbar from './Topbar'
import SideMenu from './SideMenu'

const Header = () => {
    const { currentPage, memberModalVisible, showIntroLogo } = useContext(UIContext)
    const [isLight, setIsLight] = useState(false)
    const [isVisible, setIsVisible] = useState(false)
    const [isMember, setIsMember] = useState(false)

    useEffect(() => {
        if (memberModalVisible) {
            setIsLight(false)
            setIsMember(true)
        } else if (currentPage && ['team-partners', 'contact'].includes(currentPage)) {
            setIsLight(true)
            setIsMember(false)
        } else {
            setIsLight(false)
            setIsMember(false)
        }
    }, [currentPage, memberModalVisible])    

    useEffect(() => {
        setIsVisible(showIntroLogo === false)
    }, [showIntroLogo])

    return (
        <AnimatePresence mode="wait">
            {isVisible && (
                <header
                    key="mga-header"
                    className={`mga-header${currentPage === 'contact' ? ' mga-header--contact' : (isLight ? ' mga-header--light' : (isMember ? ' mga-header--member' : ''))}`}
                >
                    <Topbar isLight={isLight} />
                    <SideMenu />
                </header>
            )}
        </AnimatePresence>
    )
}

export default Header
